import { combineReducers } from 'redux';

import actionTypes from './actionTypes';
import defaults from './defaults';

const dateFromReducer = (state = defaults.dateFrom, action) => {
    switch (action.type) {
        case actionTypes.RESET_REPORT_SECTION:
            return action.payload.section === 'dateFrom' ? action.payload.value : state;
        case actionTypes.SET_DATE_FROM:
            return action.payload.dateFromString;
        case actionTypes.HYDRATE_CURRENT_REPORT:
            return action.payload.dateFrom || state;
        default:
            return state;
    }
};

const dateToReducer = (state = defaults.dateTo, action) => {
    switch (action.type) {
        case actionTypes.RESET_REPORT_SECTION:
            return action.payload.section === 'dateTo' ? action.payload.value : state;
        case actionTypes.SET_DATE_TO:
            return action.payload.dateToString;
        case actionTypes.HYDRATE_CURRENT_REPORT:
            return action.payload.dateTo || state;
        default:
            return state;
    }
};

const gameTypeIdReducer = (state = defaults.gameTypeId, action) => {
    switch (action.type) {
        case actionTypes.SET_GAME_TYPE:
            return action.payload.gameTypeId;
        case actionTypes.HYDRATE_CURRENT_REPORT:
            return action.payload.gameTypeId || state;
        default:
            return state;
    }
};

const isAggregateReducer = (state = defaults.isAggregate, action) => {
    switch (action.type) {
        case actionTypes.SET_IS_AGGREGATE:
            return action.payload.isAggregateFlag;
        case actionTypes.HYDRATE_CURRENT_REPORT:
            if (action.payload.isAggregate === undefined) {
                return state;
            }
            return typeof action.payload.isAggregate === 'boolean'
                ? action.payload.isAggregate
                : action.payload.isAggregate === 1;
        default:
            return state;
    }
};

const isDateRangeFromSeasonsReducer = (state = defaults.isDateRangeFromSeasons, action) => {
    switch (action.type) {
        case actionTypes.SET_IS_DATE_RANGE_FROM_SEASONS:
            return action.payload.isDateRangeFromSeasons;
        case actionTypes.HYDRATE_CURRENT_REPORT:
            if (action.payload.isDateRangeFromSeasons === undefined) {
                return state;
            }
            return action.payload.isDateRangeFromSeasons;
        default:
            return state;
    }
};

const franchiseIdReducer = (state = defaults.franchiseId, action) => {
    switch (action.type) {
        case actionTypes.SET_FRANCHISE_ID:
            return action.payload.franchiseId;
        case actionTypes.HYDRATE_CURRENT_REPORT:
            return action.payload.franchiseId !== null ? action.payload.franchiseId : state;
        default:
            return state;
    }
};

const positionReducer = (state = defaults.positionCode, action) => {
    switch (action.type) {
        case actionTypes.SET_POSITION:
            return action.payload.positionCode;
        case actionTypes.HYDRATE_CURRENT_REPORT:
            return action.payload.positionCode !== null ? action.payload.positionCode : state;
        default:
            return state;
    }
};

const reportNameReducer = (state = defaults.reportName, action) => {
    switch (action.type) {
        case actionTypes.RESET_REPORT_SECTION:
            return action.payload.section === 'reportName' ? action.payload.value : state;
        case actionTypes.SET_REPORT_NAME:
            return action.payload.reportName;
        case actionTypes.HYDRATE_CURRENT_REPORT:
            return action.payload.reportName || state;
        default:
            return state;
    }
};

const seasonFromReducer = (state = defaults.seasonFrom, action) => {
    switch (action.type) {
        case actionTypes.SET_SEASON_FROM:
            return action.payload.seasonId;
        case actionTypes.HYDRATE_CURRENT_REPORT:
            return action.payload.seasonFrom || state;
        default:
            return state;
    }
};

const seasonToReducer = (state = defaults.seasonTo, action) => {
    switch (action.type) {
        case actionTypes.RESET_REPORT_SECTION:
            return action.payload.section === 'seasonTo' ? action.payload.value : state;
        case actionTypes.SET_SEASON_TO:
            return action.payload.seasonId;
        case actionTypes.HYDRATE_CURRENT_REPORT:
            return action.payload.seasonTo || state;
        default:
            return state;
    }
};

const timeFrameReducer = (state = defaults.timeFrame, action) => {
    switch (action.type) {
        case actionTypes.SET_REPORT_TIME_FRAME:
            return action.payload.timeFrame;
        case actionTypes.HYDRATE_CURRENT_REPORT:
            return action.payload.timeFrame !== undefined ? action.payload.timeFrame : state;
        default:
            return state;
    }
};

const reducer = combineReducers({
    dateFrom: dateFromReducer,
    dateTo: dateToReducer,
    gameTypeId: gameTypeIdReducer,
    isAggregate: isAggregateReducer,
    isDateRangeFromSeasons: isDateRangeFromSeasonsReducer,
    franchiseId: franchiseIdReducer,
    positionCode: positionReducer,
    reportName: reportNameReducer,
    seasonFrom: seasonFromReducer,
    seasonTo: seasonToReducer,
    timeFrame: timeFrameReducer,
});

export default reducer;
